const LOCALE_PREFIX_PATTERN = /^\/(en|it|es|fr|de)(?=\/|$)/;

export const withCurrentLocalePath = (
  targetPath: string,
  currentPath = typeof window !== 'undefined' ? window.location.pathname : ''
): string => {
  if (!targetPath.startsWith('/') || LOCALE_PREFIX_PATTERN.test(targetPath)) {
    return targetPath;
  }

  const localePrefix = currentPath.match(LOCALE_PREFIX_PATTERN)?.[0] || '';
  if (!localePrefix) {
    return targetPath;
  }

  return targetPath === '/' ? localePrefix : `${localePrefix}${targetPath}`;
};
